import React from "react";
import { IoIosSearch } from "react-icons/io";
import "./searchInput.styles.css";

const SearchInput = ({ searchTerm, setSearchTerm, borderColor = "#ddd" }) => {
    const handleSearch = (e) => {
        e.preventDefault();
    };

    return (
        <div className="search-container">
            <form className="w-100" onSubmit={handleSearch}>
                <div className="search-input-wrapper">
                    <span className="search-icon"><IoIosSearch/></span>
                    <input
                        type="text"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="search-input"
                        style={{ borderColor: borderColor }} // Apply dynamic border color
                        placeholder="Search..."
                    />
                </div>
            </form>
        </div>
    );
};

export default SearchInput;
